import { push }                                                                                                                                               from 'connected-react-router';
import { clearSection, dmpCommandFailureContextualizedType, dmpCommandSuccessContextualizedType }                                                            from 'dmpconnectjsapp-base/actions';
import { formatGetDocumentContentByUniqueIdParams, formatGetDocumentsContentByUniqueIdParams }                                                               from 'dmpconnectjsapp-base/actions/config/commandParamsFormatters';
import commands                                                                                                                                               from 'dmpconnectjsapp-base/actions/config/commands';
import { accessModes, apiSections }                                                                                                                          from 'dmpconnectjsapp-base/constants';
import { getCurrentPathname }                                                                                                                                from 'dmpconnectjsapp-base/helpers/accessors';
import { documentStatuses, findDocumentParamsDefault }                                                                                                       from 'dmpconnectjsapp-base/helpers/findDocuments';
import { getAccessRightsProps, isTransactionAllowed, transactions }                                                                                          from 'dmpconnectjsapp-base/rules/accessRights';
import { parseHrDocument }                                                                                                                                   from 'dmpconnectjsapp-base/utils/clinicalDocument';
import { encodeIns }                                                                                                                                         from 'dmpconnectjsapp-base/utils/insUtils';
import * as moment                                                                                                                                            from 'moment';
import { toast }                                                                                                                                             from 'react-toastify';
import { call, put, select, take }                                                                                                                           from 'redux-saga/effects';
import { findDocuments, getAction, removeDocFromPersistantData, removeDocumentFromCache, saveParsedHr, showUploadDocumentModal, updateDocumentsNextVersion } from '../actions';
import { dmpStatuses, documentFormats, userAuthorizationStatuses }                                                                                           from '../constants';
import { getDirectAuthenticationStatus }                                                                                                                     from '../helpers/directAuthenticationDMPStatus';
import { getCachedHr, getLastHR }                                                                                                                            from '../helpers/documentUtils';
import { getCdaContent }                                                                                                                                     from '../helpers/findDocuments';
import { getDocumentsUrl }                                                                                                                                    from '../helpers/nav';
import { explodeUniqueUUid, getUniqueUUid }                                                                                                                  from '../rules/documentRules';
import { b64DecodeUnicode, objectWithoutTheseKeys }                                                                                                          from '../utils/dataUtils';
import { getBaseName }                                                                                                                                        from "../utils/redirect";
import { saveStatInPersistantData }                                                                                                                          from './persistantDataSaga';
import { handleSentDocument }                                                                                                                                from './sendDocumentSaga';
import { getDocumentInfoFromCache, getFindDocumentsLastSearchTimeStamp, getLastApprovedNewDocFromCache, getNewDocFromCache }                                 from './utilsSagas';

export const handleGetAndParseLastHR = function * (action) {
  const { data: { Documents = [] }, context: { subSection } } = action;
  const cachedHr                                              = yield select(getCachedHr, subSection);
  
  const lastHr = getLastHR(Documents);
  if (lastHr) {
    const documentId = getUniqueUUid(lastHr.s_uniqueId, lastHr.s_uuid);
    
    if (documentId !== (cachedHr.documentId || '')) {
      yield put(getAction(
        commands.getDocumentContentByUniqueId,
        apiSections.DOCUMENT_CONTENT_SECTION,
        {
          ...formatGetDocumentContentByUniqueIdParams(subSection, lastHr.s_uniqueId, lastHr.s_uuid),
          i_getCdaContent: 1,
        },
        {
          subSection: getUniqueUUid(lastHr.s_uniqueId, lastHr.s_uuid),
        },
      ));
      
      const result                                           = yield take(dmpCommandSuccessContextualizedType(apiSections.DOCUMENT_CONTENT_SECTION));
      const { context: { subSection: gotDocumentId }, data } = result;
      if (documentId === gotDocumentId) {
        const cdaContent = getCdaContent(data);
        const parsedHr   = parseHrDocument(b64DecodeUnicode(cdaContent));
        yield put(saveParsedHr(subSection, documentId, parsedHr));
      }
    }
  }
};

const findDocumentsProcess = function * (ins, typeCodes = []) {
  const findDocumentsParams = { ...findDocumentParamsDefault };
  const lastSearchTimestamp = yield select(getFindDocumentsLastSearchTimeStamp, ins);
  yield put(clearSection(apiSections.FIND_DOCUMENTS_SECTION));
  findDocumentsParams.status = documentStatuses.ALL;
  yield put(findDocuments(ins, { ...findDocumentsParams, categories: typeCodes, lastSearchTimestamp }));
};

const findDocumentsProcessFromTo = function * (ins, from, to) {
  const findDocumentsParams                   = { ...findDocumentParamsDefault };
  findDocumentsParams.submissionStartDate     = from;
  findDocumentsParams.submissionStartDateHour = '00:00:00';
  findDocumentsParams.submissionEndDate       = to;
  findDocumentsParams.submissionEndDateHour   = '23:59:59';
  yield put(clearSection(apiSections.FIND_DOCUMENTS_SECTION));
  findDocumentsParams.status = documentStatuses.ALL;
  yield put(findDocuments(ins, { ...findDocumentsParams, categories: [] }));
};

export const refreshDocuments = function * (action) {
  
  const { command, context, data: { s_uniqueId } } = action;
  const { accessRights }                           = yield select(getAccessRightsProps);
  
  yield call(handleSentDocument, action);
  
  yield call(saveStatInPersistantData, action);
  yield take([
    dmpCommandSuccessContextualizedType(apiSections.SET_PERSISTANT_DATA),
    dmpCommandFailureContextualizedType(apiSections.SET_PERSISTANT_DATA),
  ]);
  
  const pathname = yield select(getCurrentPathname);
  
  if (pathname.startsWith(`${getBaseName(false)}/dmp`)) {
    const directAuthStatus = yield select(getDirectAuthenticationStatus, command.s_ins);
    const {
            ExistingTestAnswer: {
              i_dmpStatus        : dmpStatus,
              i_userAuthorization: authorization,
            } = {},
          }                = directAuthStatus;
    
    // lancer la recherche si le dmp existe
    // et
    // on est autorisé ou en bris de glace / centre15
    if (
      dmpStatus === dmpStatuses.DMPExist
      && (
        [accessModes.Centre15, accessModes.BrisDeGlace].includes(accessRights.accessMode)
        || authorization === userAuthorizationStatuses.AuthorizationExist
      )
    ) {
      if (isTransactionAllowed(accessRights, transactions.FIND_DOCUMENTS_META)) {
        yield call(
          findDocumentsProcess,
          command.s_ins,
          command.i_documentFormat === documentFormats.vacNote || command.i_format === documentFormats.vacNote ? ['11369-6', '87273-9'] : [],
        );
        if (!!command.s_replacedDocumentUniqueId) {
          yield take([
            dmpCommandSuccessContextualizedType(apiSections.FIND_DOCUMENTS_SECTION),
            dmpCommandFailureContextualizedType(apiSections.FIND_DOCUMENTS_SECTION),
          ]);
          
          // on lance une recherche sur la date d'ajout du document remplacé, pour le mettre à jour
          const previousDocument = yield select(
            getDocumentInfoFromCache,
            command.s_ins,
            getUniqueUUid(command.s_replacedDocumentUniqueId, context.replacedDocumentUUid),
          );
          if (previousDocument !== undefined) {
            const submissionDate = moment.utc(previousDocument.s_submissionDate, 'YYYYMMDDHHmmss');
            yield call(
              findDocumentsProcessFromTo,
              command.s_ins,
              submissionDate.format('DD/MM/YYYY'),
              submissionDate.format('DD/MM/YYYY'),
            );
            yield take([
              dmpCommandSuccessContextualizedType(apiSections.FIND_DOCUMENTS_SECTION),
              dmpCommandFailureContextualizedType(apiSections.FIND_DOCUMENTS_SECTION),
            ]);
          }
          
          // si on est sur la page document, on remplace par le nouveau doc
          const pathname = yield select(getCurrentPathname);
          if (pathname.indexOf('/document/') !== -1) {
            // cacher la modal de dépôt
            yield put(showUploadDocumentModal(false, null, null));
            
            // pas de redirection si vacNote
            if (!(command.i_documentFormat === documentFormats.vacNote || command.i_format === documentFormats.vacNote)) {
              // récupérer les infos du nouveau document
              const newDoc = yield select(getNewDocFromCache, command.s_ins, s_uniqueId, context.replacedDocumentUUid);
              
              // renvoi vers le nouveau document si page de details
              yield put(push(`${getBaseName(false)}/dmp/${encodeIns(command.s_ins)}/document/${encodeIns(getUniqueUUid(s_uniqueId, newDoc.s_uuid))}`));
            }
          }
        }
      }
    }
  }
};

export const refreshDocumentsAfterDelete = function * (action) {
  const {
          command: {
            s_uniqueId, s_documentUniqueId, s_uuid, s_documentUuid, s_ins,
          },
        } = action;
  
  toast.success('Le document a été supprimé avec succès');
  
  yield put(removeDocFromPersistantData(s_uniqueId || s_documentUniqueId, s_uuid || s_documentUuid, s_ins));
};

export const refreshDocumentsAfterDocumentUpdate = function * ({ context: { ins, section, subSection: uniqueUUid } }) {
  toast.success('Le document a été mis à jour avec succès');
  
  // si on est sur la page de contenu du document
  // const pathname = yield select(getCurrentPathname);
  // if (pathname.search('/document/') !== -1) {
  // rechercher uniquement le document mis à jour
  const document       = yield select(getDocumentInfoFromCache, ins, uniqueUUid);
  const submissionDate = moment.utc(document.s_submissionDate, 'YYYYMMDDHHmmss');
  
  const params                   = { ...findDocumentParamsDefault };
  params.submissionStartDate     = submissionDate.format('DD/MM/YYYY');
  params.submissionStartDateHour = '00:00:00';
  params.submissionEndDate       = submissionDate.format('DD/MM/YYYY');
  params.submissionEndDateHour   = '23:59:59';
  params.status                  = documentStatuses.ALL;
  params.categories              = [];
  
  yield put(clearSection(apiSections.FIND_DOCUMENTS_SECTION));
  yield put(findDocuments(ins, params));
  
  if (section === apiSections.UPDATE_DOCUMENT_VISIBILITY_SECTION) {
    // après la mise à jour de la liste, on affiche le nouveau doc
    yield take([
      dmpCommandSuccessContextualizedType(apiSections.FIND_DOCUMENTS_SECTION),
      dmpCommandFailureContextualizedType(apiSections.FIND_DOCUMENTS_SECTION),
    ]);
    
    const pathname = yield select(getCurrentPathname);
    if (pathname.indexOf('/document/') !== -1) {
      // cacher la modal de dépôt
      const { uniqueId, uuid } = explodeUniqueUUid(uniqueUUid);
      // récupérer les infos du nouveau document
      const newDoc             = yield select(getLastApprovedNewDocFromCache, ins, uniqueId, uuid);
      
      // renvoi vers le nouveau document si page de details
      yield put(push(`${getBaseName(false)}/dmp/${encodeIns(ins)}/document/${encodeIns(getUniqueUUid(uniqueId, newDoc.s_uuid))}`));
    }
  }
};

export const refreshDocumentsAfterParamsChanged  = function * ({ ins, refresh }) {
  if (refresh) {
    yield call(findDocumentsProcess, ins);
  }
};

export const checkAndUpdatePreviousVersions = function * (action) {
  const { command: { s_ins }, data: { Documents: receivedDocs = [] } } = action;
  
  const cachedDocs = yield select((state) => {
    const {
            dmpconnectDocumentsCache: {
              [s_ins]: { documents } = {},
            } = {},
          } = state;
    return documents;
  });
  
  const receivedDocsWithAPreviousVersion = receivedDocs.filter(doc => !!doc.s_previousUUId);
  const receivedDocsPreviousIds          = receivedDocs.map(doc => doc.s_previousUUId);
  const relatedCachedDocs                = Object.values(cachedDocs).filter(doc => !doc.s_nextUUId && receivedDocsPreviousIds.includes(doc.s_uuid));
  
  const docsToUpdate = relatedCachedDocs.reduce((updates, doc) => {
    const lastVersion = receivedDocsWithAPreviousVersion.find(d => d.s_previousUUId === doc.s_uuid);
    if (lastVersion) {
      return [
        ...updates, {
          uniqueUUid: getUniqueUUid(doc.s_uniqueId, doc.s_uuid),
          nextUUId  : lastVersion.s_uuid,
        },
      ];
    }
    return updates;
  }, []);
  
  if (docsToUpdate.length > 0) {
    yield put(updateDocumentsNextVersion(docsToUpdate, s_ins));
  }
};

export const getDocumentsAfterFindDocumentsImagery = function * (action) {
  const { command: { s_ins }, data: { Documents: receivedDocs = [] } } = action;
  yield put(clearSection(apiSections.GET_DOCUMENTS_IMAGERY_SECTION));
  if (receivedDocs.length > 0) {
    yield put(getAction(
      commands.getDocumentsContentByUniqueId,
      apiSections.GET_DOCUMENTS_IMAGERY_SECTION,
      formatGetDocumentsContentByUniqueIdParams(
        s_ins,
        receivedDocs.map(doc => doc.s_uniqueId),
        receivedDocs.map(doc => doc.s_uuid),
      ),
      {
        subSection   : s_ins,
        contextParams: {
          uniqueIds: receivedDocs.map(doc => doc.s_uniqueId),
          uuids    : receivedDocs.map(doc => doc.s_uuid),
        },
      },
    ));
  }
};

export const findReferencedDocuments = function * (action) {
  const
    {
      context: { params: { s_ins, anatomyImagery, modalityImagery, categories, ...params } },
      data   : { Documents: receivedDocs = [] },
    } = action;
  
  if (receivedDocs.length > 0) {
    
    yield put(findDocuments(
      s_ins,
      {
        ...params,
        categories  : ['18748-4'],
        s_ins,
        ReferenceIds: receivedDocs.reduce(
          (result, doc) => {
            if (doc.ReferenceIds && doc.ReferenceIds.length > 0) {
              return [
                ...result,
                ...doc.ReferenceIds.map(ref => ({
                  ...objectWithoutTheseKeys(ref, ['s_typecodeDescription']),
                  s_identifier      : ref.s_identifier,
                  i_approxIdentifier: 0,
                })),
              ];
            }
            
            return result;
          },
          [],
        ),
      },
      apiSections.FIND_DOCUMENTS_REFERENCED_SECTION,
    ));
  }
};

export const refreshHVAfterDeleteOrUpdate = function * (action) {
  const { command: { s_ins } = {}, context: { lastOne, hvUniqueId } } = action;
  
  const params      = { ...findDocumentParamsDefault };
  params.status     = documentStatuses.APPROVED;
  params.categories = ['11369-6'];
  
  yield put(clearSection(apiSections.FIND_DOCUMENTS_SECTION));
  yield put(findDocuments(s_ins, params));
  
  if (lastOne) {
    yield put(push(getDocumentsUrl(s_ins)));
    yield put(removeDocumentFromCache(hvUniqueId, s_ins));
  }
  
  let hvSearchResult;
  while (!hvSearchResult) {
    const result = yield take([
      dmpCommandSuccessContextualizedType(apiSections.FIND_DOCUMENTS_SECTION),
      dmpCommandFailureContextualizedType(apiSections.FIND_DOCUMENTS_SECTION),
    ]);
    
    const { context: { subSection }, command: { Categories } } = result;
    
    if (subSection === s_ins && Object.values(Categories).includes('11369-6')) {
      hvSearchResult = result;
    }
  }
  
  const { type, data } = hvSearchResult;
  if (type === dmpCommandSuccessContextualizedType(apiSections.FIND_DOCUMENTS_SECTION)) {
    const { Documents } = data;
    const hv            = Documents.find(doc => doc.i_document_Format === documentFormats.hv);
    if (hv) {
      yield put(push(`${getBaseName(false)}/dmp/${encodeIns(s_ins)}/document/${encodeIns(getUniqueUUid(hv.s_uniqueId, hv.s_uuid))}`));
    }
  }
};
